import { z } from 'zod';

/**
 * Zod schemas for runtime validation
 */

export const CoordinatesSchema = z.object({
  lat: z.number().min(-90).max(90),
  lng: z.number().min(-180).max(180),
});

export const LocationSchema = z.object({
  id: z.string(),
  name: z.string().min(1, 'Name is required'),
  coordinates: CoordinatesSchema,
  country: z.string().min(1, 'Country is required'),
  description: z.string(),
  images: z.array(z.string()),
  category: z.string().optional(),
  isLandmark: z.boolean().optional(),
});

export const BaseBucketItemSchema = z.object({
  id: z.string(),
  title: z.string().min(1, 'Title is required'),
  description: z.string(),
  completed: z.boolean(),
  dateAdded: z.string(),
  completionDate: z.string().optional(),
  notes: z.string(),
  images: z.array(z.string()),
  ownerId: z.string().optional(),
  sharedWith: z.array(z.string()).optional(),
});

export const PlaceItemSchema = BaseBucketItemSchema.extend({
  category: z.literal('place'),
  location: LocationSchema,
});

export const ExperienceItemSchema = BaseBucketItemSchema.extend({
  category: z.literal('experience'),
  experienceCategory: z.enum([
    'adventure',
    'personal-milestone',
    'creative',
    'social',
    'learning',
    'career',
    'health',
    'travel',
    'other',
  ]),
  tags: z.array(z.string()),
  difficulty: z.enum(['easy', 'moderate', 'challenging', 'extreme']).optional(),
  linkedLocationId: z.string().optional(),
});

export const BucketItemSchema = z.discriminatedUnion('category', [
  PlaceItemSchema,
  ExperienceItemSchema,
]);
